import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/components/IndexPage';
import DiscussionList from 'flarum/components/DiscussionList';
import NoSearchResults from '../components/NoSearchResults';
import app from 'flarum/forum/app';

export default function extendNoSearchResults() {
    const originalView = DiscussionList.prototype.view;

    DiscussionList.prototype.view = function() {
        const vdom = originalView.call(this);
        const searchTerm =  app.search.value || '';
        const currentRoute = m.route.get();

        if (currentRoute !== '/following') {
            if (vdom.attrs && vdom.attrs.className && vdom.attrs.className.includes('DiscussionList')) {
                const children = vdom.children || [];

                for (let child of children) {
                    if (child.attrs && child.attrs.text 
                            && child.attrs.text.join() === app.translator.trans('core.forum.discussion_list.empty_text').join()) {
                        child.attrs.text = <NoSearchResults searchTerm={searchTerm} />;
                        break;
                    }
                }
            }
        }
        return vdom;
    };

    extend(IndexPage.prototype, 'view', function (vdom) {
        const results = vdom.children[1].children[0].children[1];
        
        if (results && results.attrs && results.attrs.className === 'IndexPage-results sideNavOffset') {
            const discussionList = results.children[1];
            const discussionListData = discussionList?.attrs?.state?.pages[0]?.items?.payload?.data;

            if (discussionListData !== 'undefined' && !discussionListData?.length) {
                results.children[0].attrs.style = {display: 'none'};
            }
        }
    });
};
